module.exports = __webpack_public_path__ + "img/bilibili-winter-tree-3.77be716a.77be716a.png";